module.exports = function($) {
    class Theorie{

        constructor(){
            this.init();
            this.bind();
            this.Quizz_settings = (typeof theorie != 'undefined')? theorie : {};
            this.Quizz_responses = {
                number: 0,
                values: []
            };

        }

        init(){
            if( $('.block-theorie').length == 0 || $('.block-pratique').length ){
                return;
            }
            this.getOffset();
        }

        getOffset(){
            if( $('.block-theorie').length && $('.block-pratique').length ){
                this.t1 = $('.block-theorie').offset().top;
                this.t2 = $('.block-pratique').offset().top;
            }
        }

        scroll(){
            let scroll = $(window).scrollTop();
            if( scroll + 200 >= this.t1 ){
                $('.btn-sticky-right').addClass('visible');
            } else {
                $('.btn-sticky-right').removeClass('visible');
            }
            if( scroll + 200 >= this.t2 ){
                $('.btn-sticky-left').addClass('visible');
            } else {
                $('.btn-sticky-left').removeClass('visible');
            }

            if( scroll >= $('.masthead-election').height() / 2 ){
                $('.ResetAll').addClass('visible');
            } else {
                $('.ResetAll').removeClass('visible');
            }
        }

        resize(){
            this.getOffset();
        }

        bind(){
            const _this = this;

            $('.quizz-step input').on('change', function(){
                let index = $(this).closest('.item').index() + 1;
                let $q = $(this).closest('.quizz-step');
                if( $q.find('.item-'+index).length) {
                    $q.find('.item-'+index).css({'display':'block'});
                }
            });

            $('.block-theorie--quizz input[type="radio"]').on('change', function(){
                let value = $(this).val();
                let index = $(this).closest('.item').index();

                if( _this.Quizz_responses.number < _this.Quizz_settings.number ){
                    _this.Quizz_responses.number += 1;
                    _this.Quizz_responses.values.push(parseInt(value));
                } else {
                    _this.Quizz_responses.values[index] = parseInt(value);
                }

                _this.quizz_resolve();
            });


            $(window).on('scroll', function (e) {
                _this.getOffset();
                _this.scroll();
            });

            $(window).on('resize', function (e) {
                _this.resize();
            });
        }

        quizz_resolve(){
            let result = true;
            if( this.Quizz_settings.number == this.Quizz_responses.number ){
                for( let i in this.Quizz_settings.values ){
                    if(this.Quizz_settings.values[i] != this.Quizz_responses.values[i]){
                        result = false;
                    }
                }
                if( result == true ){
                    $('.block-theorie--quizz .message--2.alert-warning').addClass('d-none');
                    $('.block-theorie--quizz .message--2.alert-success').removeClass('d-none');
                    $('.block-theorie--quizz .message-after').addClass('d-none');
                    $("html, body").animate({ scrollTop: $('.block-theorie--quizz .message--2.alert-success').offset().top - 100 }, 400 );
                } else {
                    $('.block-theorie--quizz .message--2.alert-warning').removeClass('d-none');
                    $('.block-theorie--quizz .message--2.alert-success').addClass('d-none');
                    $('.block-theorie--quizz .message-after').removeClass('d-none');
                    $("html, body").animate({ scrollTop: $('.block-theorie--quizz .message--2.alert-warning').offset().top - 100 }, 400 );
                }
            }
        }
    }
    return new Theorie;
}
